import Checkbox from './Checkbox';
import ColorField from './ColorField';
import DateField from './DateField';
import DateStartEndField from './DateStartEndField';
import EmailField from './EmailField';
import InputField from './InputField';
import NumberField from './NumberField';
import RadioButton from './RadioButton';
import TextInputField from './TextInputField';
import TypeaheadInput from './TypeaheadInput';
import TimePickerField from './TimePickerField';
import SelectField from './SelectField';
import TextAreaField from './TextAreaField';
import BootstrapSelect from './BootstrapSelect';
import MultiplePhoneField from './MultiplePhoneField';
import MultipleEmailField from './MultipleEmailField';
import TagsInput from './TagsInput';
import PhoneField from './PhoneField';
import MultipleInventoryField from './MultipleInventoryField';
import MultipleEmailType from './MultipleEmailType';
import SchedulePicker from './SchedulePicker';
import MultipleEmergencyContact from './MultipleEmergencyContact';

export {
	Checkbox,
	ColorField,
    DateField,
	DateStartEndField,
    EmailField,
    InputField,
    NumberField,
    RadioButton,
    TextInputField,
    TypeaheadInput,
	TimePickerField,
    SelectField,
    TextAreaField,
	BootstrapSelect,
    MultiplePhoneField,
    MultipleEmailField,
    TagsInput,
	PhoneField,
    MultipleInventoryField,
    MultipleEmailType,
    SchedulePicker,
    MultipleEmergencyContact
}



/** WEBPACK FOOTER **
 ** ./src/commons/Inputs/index.js
 **/